import {useCallback} from 'react';
import {useLanguage} from './useLanguage';
import {VopBeneficiaryStatus} from '../redux/@types/PaymentProTypes';

export interface PushAnalyticsParams {
  rule: String,
  actionName?: String,
  buttonName?: String,
  pageName?: String,
  stepName?: String,
  sequenceName?: String,
  currencyName?: String,
  messageSubject?: String,
  starsNumber?: Number,
  sectionName?: String,
  vopStatus?: VopBeneficiaryStatus
  transactionType?: String,
  platformName?: String,
  transferType?: String
}

let currentPage: String;

export const useAnalytics = () => {
  const PLATFORM_NAME = 'webbanking_pro';
  const language = useLanguage();
  const pushAnalytics = useCallback((pushAnalyticsParams: PushAnalyticsParams) => {
    if (pushAnalyticsParams.pageName) {
      currentPage = pushAnalyticsParams.pageName;
    }
    // @ts-ignore
    window?.pushAnalytics({
      platformName: PLATFORM_NAME,
      country: language,
      trackingRule: pushAnalyticsParams.rule,
      userActionName: pushAnalyticsParams.actionName,
      buttonName: pushAnalyticsParams.buttonName,
      pageName: currentPage,
      stepName: pushAnalyticsParams.stepName,
      sequenceName: pushAnalyticsParams.sequenceName,
      currencyName: pushAnalyticsParams.currencyName,
      messageSubject: pushAnalyticsParams.messageSubject,
      starsNumber: pushAnalyticsParams.starsNumber,
      sectionName: pushAnalyticsParams.sectionName,
      vopStatus: pushAnalyticsParams.vopStatus?.toString(),
      transactionType: pushAnalyticsParams.transactionType,
      transferType: pushAnalyticsParams.transferType,
    });
  }, [language]);

  return {
    pushAnalytics
  };
};

